var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecureActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 8.75V12.25M6.51623 2.9934C7.64698 2.2094 9.01984 1.75 10.5 1.75C14.366 1.75 17.5 4.88401 17.5 8.75V9.83208M3.86428 6.51531C3.62804 7.21708 3.5 7.96859 3.5 8.75V12.25C3.5 15.4305 5.62114 18.1156 8.52596 18.9678M17.2015 14.2789C16.5632 16.3899 14.9547 18.0798 12.8947 18.8297M12.5343 5.37806C11.9406 5.01909 11.2444 4.8125 10.5 4.8125C8.32538 4.8125 6.5625 6.57538 6.5625 8.75V11.3312M14.4375 9.66V12.25C14.4375 14.4246 12.6746 16.1875 10.5 16.1875C9.75743 16.1875 9.06287 15.9819 8.47012 15.6246",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureActive);
export default __webpack_public_path__ + "static/media/secure-active.eb730b3276c02e5b3629f3e191d9074f.svg";
export { ForwardRef as ReactComponent };